import React from "react";
import { useDispatch } from "react-redux";
import * as siteMaster from "~/data/actions/siteActions";
import i18n from '~/i18n'
import MergeChecker from "./mergeTagChecker";

const CheckMergeTagsButton = ({ html, onStart, onClick, ...rest }) => {
    const dispatch = useDispatch();

    async function checkTags() {
        if (onClick && typeof (onClick === "function")) {
            const result = await onClick();
            if (typeof result === 'boolean' && result === false) return
        }

        if (onStart && typeof onStart === 'function') {
            html = onStart()
        }

        const drawerContent = <MergeChecker html={html} id={rest.id} type={rest.type} landingPage={rest.landingPage} />;

        dispatch(
            siteMaster.alterSiteDrawer(
                true,
                true,
                "right",
                drawerContent,
                true,
                "500px"
            )
        );
    }

    return (
        <li data-ph="dragdrop-check-merge-tags" onClick={checkTags} {...rest}>
            {i18n.t('templates:add.drag.checkMergeTags')}
        </li>
    );
};

export default CheckMergeTagsButton;
